
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import FigureItem  from "components/FigureItem";
import NuCheckbox from "components/nubox/NuCheckbox"
import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
  
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TablaNotasFin extends React.Component {
  state = {

    modalImagen: false,
    
    fecha:'',
    bimestre:0,
    form: Object.assign({}, initialForm),

    dataList: [],/* lista  */
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    
    
    this.cargar_data();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //let id_asisfe = this.props.params.id;

    let bimestre = this.props.params.id;
    this.setState({bimestre: bimestre})
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;              
      //------------------------------------------------

      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
      

    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  //-------------- cambiamos valor en la tabla
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.dataList];
    newData[index][columnId] = value;
    //this.setState({ datalist: newData });
    //solo tenemos que dejar pasar si es numero entero
    
    //console.log(value);
    if(value===""){
      this.setState({ datalist: newData });
      return;
    }
    //---------------------
    
    //----------------------
    const nota = parseInt(value);
    console.log(nota);
    if(!isNaN(nota)){  //si no es NAN
    //if(Number.isInteger(nota)){
      //si es numero entero
      // actualizamos el estado
      /*if(nota>=0 && nota<= 100){
        //hacemos el calculo
        //let newData1 = this.calcular(newData, index);
        
        //this.setState({ datalist: newData1 });
      }else{
        alert("Solo se permite notas entre 0 y 100")
      }*/
      
    }else{
      alert("Valor no valido")
    }
    
    //console.log(newData);
    //setData({  data: newData    });
    
  }
  
  
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,

   */
  cargar_data=()=>{
    console.log("cargar_data")
    //let id_est = this.props.store.user.id_est;
    let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;
    let bimestre = parseInt( this.props.params.id);
    

    let param = { 
      id_mate: id_mate,
      id_peri: id_peri,
      bimestre: bimestre,
    }

    console.log(param)
    axios2.post("tabla_notas_fin_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.tabla.length>0){ 
            this.setState({dataList: res.data.tabla,
              
            });
            //this.setState({columnsA: res.data.columnsA});
        }else{
          this.setState({dataList: [] });
          
            //NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  //---si el campo tiene valor vacio, lo convierte a 0
  normalizar=(num)=>{
    if(num==="") return 0;
    return num;
  }
  //-----------------------------------
  //------------------------------------
  finalizar_click =(e)=>{
    e.preventDefault();

    this.refNuConfirm.current.show({
      message: 'Esta seguro de finalizar el llenado? \n Una vez finalizado, no se podra modificar.',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        console.log("confirmar finalizar")
        this.finalizar();
        //let idd = item.id_carre;
        //this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })
  }
  //-----------------------------------
  finalizar=()=>{
    const user = this.props.store.user;
    const materia = this.props.store.materia;
    //console.log(this.state.dataList)
    let bimestre = parseInt( this.props.params.id);

    let param = { 
      id_peri: user.id_peri,
      id_mate: materia.id_mate,
      id_doc: user.id_doc,
      bimestre: bimestre,
      //tabla:  JSON.stringify( this.tabla_filter() )
      
    };
    console.log(param);
    
    axios2.post("tabla_notas_fin_finalizar", param)
    .then(res => {
        console.log(res.data);
        if(res.data.exito === 1){ 
            NotificationManager.success(res.data.men); 
            //redirigir
            //let bimestre = this.props.params.id;
            this.props.navigate('/notasd');  
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });

  }
  //-----------------------------------
  impri_borrador_notas_click=()=>{
    //---imprimirmos en pdf
    const user = this.props.store.user;
    const materia = this.props.store.materia;
    //console.log(this.state.dataList)
    let bimestre = parseInt( this.props.params.id);
    let id_mate = materia.id_mate
    let id_peri = user.id_peri
    
    let fileURL = process.env.REACT_APP_API_URL  + 'tabla_notas_fin_borrador_pdf/'+ id_mate+"/"+id_peri+"/"+bimestre;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //-------------------------------------
  //------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user
    return(
      <div>
        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form.cant_teo)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> PLANILLA DE NOTAS FINALIZAR </h3>
              <Button 
                  className="btn btn-info" 
                  onClick={this.impri_borrador_notas_click  } >
                BORRADOR DE NOTAS PDF
              </Button>
              &nbsp;
              <Button 
                  className="btn btn-danger" 
                  onClick={ this.finalizar_click } >
                FINALIZAR NOTAS
              </Button>
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre } /G { materia.grupo } <br />
                Periodo: { user.periodo } <br />
                Bimestre: { this.state.bimestre } <br />
                { /* Fecha: { this.state.fecha }<br/> */}
              </p>
            </div>

            <div className="col-md-5">
             
            </div>

          </div>

        <table className="tabla_azul  table-striped table-hover ">
          <thead>
            <tr>
              <td colSpan={2}></td>
              <td colSpan={6} className="cell_celeste">TEORICO (30 Pts)</td>
              <td colSpan={6} className="cell_rosado">PRACTICO (70 Pts)</td>
            </tr>
            <tr>
                <th width="80px">Nro</th>
                {/*<th>Nro. Doc.</th>*/}
                <th>Apellidos y Nombres</th>
                <th>Eval 1
                  
                </th>
                <th>Eval 2
                  
                </th>
                <th>Eval 3
                 
                </th>
                <th>Eval 4
                  
                </th>
                <th>Eval 5
                  
                </th>
                <td className="cell_celeste">Prom. Eval.</td>
                <th>Prac 1</th>
                <th>Prac 2</th>
                <th>Prac 3</th>
                <th>Prac 4</th>
                <th>Prac 5</th>
                <td className="cell_rosado">Prom. Pract.</td>
                <th>Val. Cuali.</th>
                <th>Nota Final</th>
            </tr>
          </thead>
          <tbody>
              
              {this.state.dataList.map((item,index) => ( 
                  <tr key={index}>
                    <td>{ index+1 }
                      { /* item.id_progra */}
                    </td>
                    {/*<td>{ item.nro_doc }</td>*/}
                    <td>{ item.nomape_tmp }</td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"e1", e.target.value)} 
                        value={item.e1 } 
                        disabled
                      />
                    </td>
                    <td><input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"e2", e.target.value)} 
                        value={item.e2 } 
                        disabled
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"e3", e.target.value)} 
                        value={item.e3 } 
                        disabled
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"e4", e.target.value)} 
                        value={item.e4 } 
                        disabled
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"e5", e.target.value)} 
                        value={item.e5 } 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"prom_teorico", e.target.value)} 
                        value={item.prom_teorico} 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50, textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"p1", e.target.value)} 
                        value={item.p1} 
                        disabled={true}
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50, textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"p2", e.target.value)} 
                        value={item.p2} 
                        disabled={true}
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50, textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"p3", e.target.value)} 
                        value={item.p3}
                        disabled={true} 
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50, textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"p4", e.target.value)} 
                        value={item.p4}
                        disabled={true} 
                      />
                    </td>
                    <td>
                      <input type="text" 
                        className='' 
                        style={{width:50, textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"p5", e.target.value)} 
                        value={item.p5}
                        disabled={true} 
                      />
                    </td>
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"prom_practicas", e.target.value)} 
                        value={item.prom_practicas} 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"valo_cualitativa", e.target.value)} 
                        value={item.valo_cualitativa} 
                        disabled
                      />
                    </td>
                    {/**------------------------------------- */}
                    <td > 
                      <input type="text" 
                        className='' 
                        style={{width:50,  textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"nota_final", e.target.value)} 
                        value={item.nota_final} 
                        disabled
                      />
                    </td>
                                  
                  </tr>
              ))}
              
          </tbody>
        </table>

       


      </div>
        

        <NotificationContainer/>
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TablaNotasFin );